import { apiRequest } from '@/utils/api-request';

interface LabelOperationResponse {
  data?: {
    workflow_id: string;
    label_id: string;
    status: string;
  };
  detail?: string;
}

export async function assignLabel(
  orgId: string,
  workflowId: string,
  labelId: string,
): Promise<LabelOperationResponse> {
  const response = (await apiRequest<LabelOperationResponse>({
    url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/labels`,
    target: 'workflow',
    method: 'POST',
    body: { label_id: labelId },
  })) as LabelOperationResponse;

  // apiRequest resolves (never throws) with a `detail` on failure — surface it
  // so callers can roll back the optimistic toggle.
  if (response.detail) {
    throw new Error(response.detail);
  }

  return response;
}

export async function removeLabel(
  orgId: string,
  workflowId: string,
  labelId: string,
): Promise<LabelOperationResponse> {
  const response = (await apiRequest<LabelOperationResponse>({
    url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/labels/${labelId}`,
    target: 'workflow',
    method: 'DELETE',
  })) as LabelOperationResponse;

  if (response.detail) {
    throw new Error(response.detail);
  }

  return response;
}
